import React, { useEffect, useCallback, useState } from "react";
import { useParams, useHistory } from "react-router";
import useTrackStatus from "../../modules/user/hooks/use-track-status";
import AnswerList from "../../components/answer-list";
import { useActiveNode } from "../../modules/user/hooks/use-active-node";
import { useSetLastVisited } from "../../modules/user/hooks/use-set-last-visited";
import './style.scss';
import VimeoPlayer from "../../components/vimeo-player";
import Clock from "../../components/clock";
import useGtagPageview from "../../utils/google-analitics/use-gtag-pageview";
import { getNodeRoute } from "../routes";

export default function TrackPage() {

    const { trackId } = useParams();
    const node = useActiveNode(trackId);
    const trackStatus = useTrackStatus(trackId);
    const history = useHistory();
    const changeNode = useSetLastVisited();
    const [isButtonsActive, setButtonsActive] = useState(false);
    const sendPageview = useGtagPageview();

    useEffect(() => {
        if (trackId && node?.id) {
            sendPageview(getNodeRoute(trackId, node?.id))
        }
    }, [sendPageview, trackId, node])

    useEffect(() => {
        if (trackStatus !== 'active') {
            history.push('/', {
                scrollToTracks: true
            })
        }
    }, [trackStatus, history])

    const onActionClicked = useCallback((id: NodeId) => {
        changeNode(trackId, id);
    }, [changeNode, trackId])

    const onTimeUpdate = useCallback((time: number) => {
        if (time > 10) {
            setButtonsActive(true)
        } else {
            setButtonsActive(false)
        }
    }, [setButtonsActive])

    const vimeoId = Number(node?.elements[0]?.value);
    const showVimeoPlayer = !isNaN(vimeoId);

    return (
        <main className='track-page column'>
            <div className="page-container">
                <aside style={{ position: 'relative' }}>
                    <Clock />
                </aside>
            </div>
            {
                node && <>
                    <div className="game-container">
                        <div className="page-container">

                            {showVimeoPlayer && <div className="video row">

                                <VimeoPlayer videoId={Number(node.elements[0]?.value)} autoplay={true} onTimeUpdate={onTimeUpdate} />

                            </div>}

                            <nav className="row action-list" style={{ margin: '40px 0' }}>
                                {node.actions.map(
                                    (a, index) => a.actionTarget && isButtonsActive ?
                                        <button key={index} className='action-button' onClick={() => onActionClicked(a.actionTarget || '')} >{a.label}</button> :
                                        <span key={index} className='action-button inactive'>{a.label}</span>
                                )}
                            </nav>
                        </div>
                    </div>

                    <AnswerList trackId={trackId} />
                </>
            }
        </main>
    )
}
